export default "__VITE_ASSET__DMooNKIl__"